<div class="container mobile-container container-space">
  <!-- Active Orders Section -->
  @if (isActiveOrdersLoading && activeOrders && activeOrders.length > 0) {
    <div class="active-orders-section">
      @if (!isMobile) {
        <div class="d-flex align-items-center justify-content-between mb-4 mt-4">
          <div class="Title-account d-flex flex-column align-items-start justify-content-start">
            <span aria-hidden="true"
                  class="skeleton skeleton-line orders-skeleton-title"></span>
            <span aria-hidden="true"
                  class="skeleton skeleton-line orders-skeleton-subtitle d-lg-block d-none"></span>
          </div>
        </div>
      } @else {
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="Title-account d-flex flex-column align-items-start justify-content-start">
            <span aria-hidden="true"
                  class="skeleton skeleton-line orders-skeleton-title"></span>
          </div>
        </div>
      }
      <div class="active-orders-scroll">
        @for (placeholder of activeOrdersSkeletonPlaceholders; track $index) {
          <div class="active-order-card orders-skeleton-card">
            <div class="orders-skeleton-card-top d-flex align-items-start gap-3">
              <span aria-hidden="true"
                    class="skeleton orders-skeleton-avatar"></span>
              <div class="orders-skeleton-card-body flex-grow-1">
                <span aria-hidden="true"
                      class="skeleton skeleton-line orders-skeleton-line"></span>
                <span aria-hidden="true"
                      class="skeleton skeleton-line orders-skeleton-line-sm"></span>
                <span aria-hidden="true"
                      class="skeleton skeleton-line orders-skeleton-line-sm"></span>
              </div>
            </div>
            <span aria-hidden="true"
                  class="skeleton orders-skeleton-progress"></span>
            <div class="orders-skeleton-footer">
              <span aria-hidden="true"
                    class="skeleton skeleton-line orders-skeleton-line"></span>
              <div class="orders-skeleton-buttons">
                <span aria-hidden="true"
                      class="skeleton orders-skeleton-button"></span>
                <span aria-hidden="true"
                      class="skeleton orders-skeleton-button"></span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  } @else if (activeOrders && activeOrders.length > 0) {
    <div class="active-orders-section">
      @if (!isMobile) {
        <div class="d-flex align-items-center justify-content-between mb-4 mt-4">
          <div class="Title-account d-flex flex-column align-items-start justify-content-start">
            <span>{{ 'ActiveOrders' | translate }}</span>
            <img class="mt-2 d-lg-block d-none"
                 src="/icons/line-categories.svg">
          </div>
        </div>
      }
      @if (isMobile) {
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="Title-account d-flex flex-column align-items-start justify-content-start">
            <span>{{ 'ActiveOrders' | translate }}</span>
          </div>
        </div>
      }
      <div [class.single-order]="activeOrders.length === 1"
           class="active-orders-scroll">
        @for (activeOrder of activeOrders; track activeOrder.FactorId) {
          <div class="active-order-card">
            <div class="active-order-content">
              <div class="active-order-icon">
                <img (error)="onImageError($event)"
                     [src]="getFirstOrderItemImage(activeOrder) || '/icons/image-placeholder.svg'"
                     alt="order-item"
                     class="order-item-icon">
              </div>
              <div class="active-order-details">
                <div class="d-flex justify-content-between w-100 align-items-center">
                  <div class="order-name">{{ getFirstOrderItemName(activeOrder) }}</div>
                  @if (activeOrder?.PaymentMethod?.Title) {
                    <span [ngClass]="activeOrder.Status === 'DELIVERED' ? 'deliver-status-box' : 'not-deliver-status-box'"
                          class="align-items-end">{{ activeOrder.PaymentMethod.Title }}</span>
                  }
                </div>
                <p style="color: rgb(114 114 121); margin-top: 4px;font-size: 14px;">
                  {{ activeOrder.CreateDate | time: 'dddd DD MMMM . hh:mm' }}
                </p>
                @if (activeOrder?.DeliveryMethod?.Type === 'INSIDE_DELIVER') {
                  <p style="color: rgb(114 114 121); margin-top: 4px;font-size: 12px">
                    {{ 'InPersonDelivery' | translate }}
                  </p>
                } @else if (activeOrder?.DeliveryMethod?.Type === 'OUTSIDE_DELIVER') {
                  <p style="color: rgb(114 114 121); margin-top: 4px;font-size: 12px">
                    {{ 'DeliverTo' | translate }}
                  </p>
                  @if (activeOrder?.UserAddress?.Title) {
                    <p style="color: rgb(42 43 53); margin-top: 4px;font-size: 12px">
                      {{ activeOrder.UserAddress.Title }}
                    </p>
                  }
                } @else {
                  <p style="color: rgb(114 114 121); margin-top: 4px;font-size: 12px">
                    {{ 'Inside' | translate }}
                  </p>
                }
              </div>
            </div>
            @if (shouldShowProgress(activeOrder)) {
              <div class="progress-tracker">
                <div class="progress-line">
                  <div [ngClass]="{'active': getProgressStage(activeOrder).icon1, 'inactive': !getProgressStage(activeOrder).icon1}"
                       class="progress-icon">
                    <img [style.filter]="getProgressStage(activeOrder).icon1 ? 'none' : 'opacity(0.5) grayscale(100%)'"
                         alt="food"
                         height="24"
                         src="/icons/food.svg"
                         width="24">
                  </div>
                  <div [style.--dash-width]="getProgressStage(activeOrder).dash1Percent + '%'"
                       [style.border-color]="getProgressStage(activeOrder).dash1Percent > 0 ? '#D68240' : '#D0D0D0'"
                       class="progress-dash"></div>
                  <div [ngClass]="{'active': getProgressStage(activeOrder).icon2, 'inactive': !getProgressStage(activeOrder).icon2}"
                       class="progress-icon">
                    <img [style.filter]="getProgressStage(activeOrder).icon2 ? 'none' : 'opacity(0.5) grayscale(100%)'"
                         alt="delivery-food"
                         height="24"
                         src="/icons/delivery-food.svg"
                         width="24">
                  </div>
                  <div [style.--dash-width]="getProgressStage(activeOrder).dash2Percent + '%'"
                       [style.border-color]="getProgressStage(activeOrder).dash2Percent > 0 ? '#D68240' : '#D0D0D0'"
                       class="progress-dash"></div>
                  <div [ngClass]="{'active': getProgressStage(activeOrder).icon3, 'inactive': !getProgressStage(activeOrder).icon3}"
                       class="progress-icon">
                    <img [style.filter]="getProgressStage(activeOrder).icon3 ? 'none' : 'opacity(0.5) grayscale(100%)'"
                         alt="deliveryman"
                         height="24"
                         src="/icons/deliveryman.svg"
                         width="24">
                  </div>
                </div>
              </div>
            }
            <div class="order-status-info">
              <div class="d-flex justify-content-between align-items-center">
                <div class="status-message">{{ getActiveOrderStatusMessage(activeOrder) }}</div>
                <p style="color: rgb(42 43 53); margin: 0; font-size: 12px; font-weight: 500;">
                  {{ 'DeliveryByHour' | translate }}: {{ deliveryTime(activeOrder) }}
                </p>
              </div>
              @if (getActiveOrderSecondaryMessage(activeOrder)) {
                <div class="status-secondary-message">{{ getActiveOrderSecondaryMessage(activeOrder) }}</div>
              }
              <div class="d-flex gap-3 mt-4">
                <div class="w-50">
                  <app-frontend-button
                    (click)="openFactorClicked(activeOrder)"
                    [title]="'FactorShow'"
                    class="factor-button">
                  </app-frontend-button>
                </div>
                @if (activeOrder?.BankStatusCode !== 0 && (activeOrder?.PaymentMethod?.Type === 'CARD_TO_CARD' || activeOrder?.PaymentMethod?.Type === 'PSP')) {
                  <div class="w-50">
                    <app-frontend-button
                      (click)="openCardToCardClicked(activeOrder)"
                      [title]="'Payment'"
                      class="payment-button">
                    </app-frontend-button>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (!isMobile) {
    <div class="d-flex align-items-center justify-content-between mb-4 mt-4">
      <div class="Title-account d-flex flex-column align-items-start justify-content-start">
        <span>{{ 'PreviousOrders' | translate }}</span>
        <img class="mt-2 d-lg-block d-none"
             src="/icons/line-categories.svg">
      </div>
    </div>
  }
  <div [class.no-margin-top]="activeOrders && activeOrders.length > 0"
       class="box-info">
    @if (isMobile) {
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div class="Title-account d-flex flex-column align-items-start justify-content-start">
          <span>{{ 'PreviousOrders' | translate }}</span>
        </div>
      </div>
    }
    @if (isPreviousOrdersLoading) {
      @for (placeholder of previousOrdersSkeletonPlaceholders; track $index; let last = $last) {
        <div class="panel-mobile orders-history-skeleton-card">
          <div class="orders-history-skeleton-header d-flex align-items-start gap-3">
            <span aria-hidden="true"
                  class="skeleton orders-history-skeleton-logo"></span>
            <div class="orders-history-skeleton-text flex-grow-1">
              <span aria-hidden="true"
                    class="skeleton skeleton-line orders-history-skeleton-title"></span>
              <span aria-hidden="true"
                    class="skeleton skeleton-line orders-history-skeleton-subtitle"></span>
            </div>
            <span aria-hidden="true"
                  class="skeleton orders-history-skeleton-status"></span>
          </div>
          <div class="orders-history-skeleton-meta">
            <span aria-hidden="true"
                  class="skeleton skeleton-line orders-history-skeleton-meta-line"></span>
            <span aria-hidden="true"
                  class="skeleton skeleton-line orders-history-skeleton-meta-line"></span>
          </div>
          <div class="orders-history-skeleton-items d-flex justify-content-between align-items-center">
            <div class="orders-history-skeleton-thumbnails d-flex align-items-center gap-2">
              @for (thumb of previousOrdersSkeletonPlaceholders; track thumb) {
                <span aria-hidden="true"
                      class="skeleton orders-history-skeleton-thumb"></span>
              }
            </div>
            <span aria-hidden="true"
                  class="skeleton skeleton-line orders-history-skeleton-price"></span>
          </div>
          <div class="orders-history-skeleton-buttons d-flex gap-3 mt-4">
            <span aria-hidden="true"
                  class="skeleton orders-skeleton-button"></span>
            <span aria-hidden="true"
                  class="skeleton orders-skeleton-button"></span>
          </div>
        </div>
        <div [class.no-line]="last"
             class="line"></div>
      }
    } @else if (count === 0) {
      <div class="head-success d-flex justify-content-center">
        <img src="/icons/empty-list.svg">
      </div>
      <div class="col-12 mt-5 px-4">
        <app-frontend-button
          [title]="'OrderNotFound'"></app-frontend-button>
      </div>
    } @else {
      @for (factor of factors; track $index; let i = $index; let last = $last) {
        <div class="panel-mobile">
          <div class="col-12 d-flex flex-column align-items-start">
            <div class="col-12 d-flex justify-content-start align-items-start">
              <div>
                <img (error)="onImageError($event)"
                     (load)="imageLoadError = false"
                     [ngClass]="{ 'rounded-image': !imageLoadError, 'no-radius': imageLoadError }"
                     [src]="formatImage('', factor?.Business?.Details?.Logo)"
                     alt="preview"
                     height="50"
                     style="margin-left: 12px;margin-top: 20px;"
                     width="50">
              </div>
              <div class="txt-order text-end w-100 mt-3">
                <div class="d-flex justify-content-between w-100">
                  <span class="align-items-start"
                        style="font-size: 14px">{{ factor?.Business?.Title | translate }}</span>
                  <span [ngClass]="factor.Status === 'DELIVERED' ? 'deliver-status-box' : 'not-deliver-status-box'"
                        class="align-items-end"
                        style="font-size: 12px">{{ getFactorStatus(factor?.Status) }}</span>
                </div>
                <p style="color: rgb(114 114 121); margin-top: 4px;font-size: 14px;">
                  {{ factor.CreateDate | time: 'dddd DD MMMM . hh:mm' }}
                </p>

                @if (factor?.DeliveryMethod?.Type === 'INSIDE_DELIVER') {
                  <p style="color: rgb(114 114 121); margin-top: 4px;font-size: 12px">
                    {{ 'InPersonDelivery' | translate }}
                  </p>
                } @else if (factor?.DeliveryMethod?.Type === 'OUTSIDE_DELIVER') {
                  <p style="color: rgb(114 114 121); margin-top: 4px;font-size: 12px">
                    {{ 'DeliverTo' | translate }}
                  </p>
                  <p style="color: rgb(42 43 53); margin-top: 4px;font-size: 12px">
                    {{ factor?.UserAddress?.Title }}
                  </p>
                } @else {
                  <p style="color: rgb(114 114 121); margin-top: 4px;font-size: 12px">
                    {{ 'Inside' | translate }}
                  </p>
                }
              </div>
            </div>
            <div class="d-flex justify-content-between w-100 mt-4">
              <!-- Scrollable image list -->
              <div class="d-flex overflow-auto pe-2 hide-scrollbar"
                   style="max-width: 80%; gap: 8px;">
                @for (factorOrder of factor.FactorOrders; track $index) {
                  <div class="image-wrapper position-relative">
                    <img
                      (error)="onImageError($event)"
                      (load)="imageLoadError = false"
                      [ngClass]="{ 'rounded-image': !imageLoadError, 'no-radius': imageLoadError }"
                      [src]="formatImage('', factorOrder.Order.ServicePrice.Service.Images[0])"
                      alt="preview"
                      height="40"
                      style="margin-left: 6px"
                      width="40">
                    <div class="badge-circle">{{ factorOrder.Order.Count }}</div>
                  </div>
                }
              </div>
              <!-- Fixed price section -->
              <div class="d-flex align-items-center justify-content-end price-food flex-shrink-0 ms-2">
                <p>{{ StringUtil.numberAsCurrency(factor.Price ?? 0) }}</p>
                <span>ریال</span>
              </div>
            </div>
          </div>
          @if (factor.Status === 'DELIVERED') {
            <div class="d-flex justify-content-between align-items-center comment-factor">
              <p style="color: #60636A;font-size: 10px;">
                نظرتان را درباره این سفارش به اشتراک بگذارید
              </p>
              <button (click)="openRegisterCommentClicked(factor.FactorId)">
                <span>{{ 'RegisterAComment' | translate }}</span>
                <img src="/icons/comment.svg">
              </button>
            </div>
          }
          <div class="d-flex gap-3 mt-4">
            <div class="w-50">
              <app-frontend-button
                (click)="openFactorClicked(factor!)"
                [title]="'FactorShow'"
                class="factor-button">
              </app-frontend-button>
            </div>
            @if (factor?.Status === 'CANCELED' || factor?.Status === 'CANCELED_BY_SYSTEM' || factor?.Status === 'DELIVERED') {
              <div class="w-50">
                <app-frontend-button
                  (click)="reOrderClicked(factor!)"
                  [title]="'ReOrder'"
                  class="factor-button">
                </app-frontend-button>
              </div>
            }
          </div>
        </div>
        <div [class.no-line]="last"
             class="line"></div>
      }
    }
  </div>
</div>
